import { gql } from '@/__generated__';

/**
 * AMARU-851 — opciones del multi-select de colecciones del formulario de creación de device:
 * ICN y CUSTOM de la organización seleccionada en el formulario.
 *
 * Control dedicado, no comparte infraestructura con StandardAutocompleteIds/icnCollections
 * (global a la app, solo ICN) — mismo patrón que
 * deviceConfigurationModal/graphql/queries/getOwnOrganizationCollections.ts (GeneralTab, flujo de
 * edición). Duplicado en vez de compartido entre features, siguiendo la convención del repo de
 * colocar las queries dentro de su propia feature — evaluar en AMARU-852 si conviene unificarlos.
 */
const GET_OWN_ORGANIZATION_COLLECTIONS = gql(`#graphql
  query CreateDevice_GetOwnOrganizationCollections($organizationId: Int!) {
    collections(filter: { organizationId: $organizationId, types: [ICN, CUSTOM] }) {
      id
      name
      type
    }
  }
`);

export default GET_OWN_ORGANIZATION_COLLECTIONS;
